import ToggleAllCheckboxesController from './toggle_all_checkboxes_controller'

export default class extends ToggleAllCheckboxesController {
  connect (): void {
    super.connect()
    this.syncSelectAllState()
  }

  syncSelectAllState (): void {
    super.syncSelectAllState()
    this.selectAllTarget.classList.toggle('indeterminate', this.selectAllTarget.indeterminate)
  }

  toggleAll (): void {
    super.toggleAll()

    const option = this.element.querySelector<HTMLInputElement>(this.targetSelectorValue)
    option?.dispatchEvent(new Event('change', { bubbles: true }))
    document.dispatchEvent(new CustomEvent('count-checkboxes:update'))
  }
}
